<div class="outer-content">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
      <div class="float-left bg-white wd-total">

        <div class="col-md-12 clear-all title-wrapper">

          <h1 class="responsive-text-8" id="beneficiary-header">{{contentData.title}} </h1>
          <span  class="Rectangle application-Reference">
              <i>Your reference no. </i>
              <span >{{applicationRefrence}}</span>
            </span>
              
        </div>
        <div  class="col-md-12 clear-all content-wrapper content-header">
        
            {{contentData.header}}
          
        </div>
        <div class="col-md-12 clear-all content-wrapper">
          <p class="content-top" id="beneficiary-introduction2">
            {{contentData.confirmationEmailInfo}}<span class="font-bold">{{registeredMail}}.</span>
          </p>
        
        </div>
        <div class="col-md-12 clear-all content-wrapper">
          <p class="content-top" id="beneficiary-introduction2">
            {{contentData.info}}
          </p>
        </div>
        <div class="col-md-12 underline margin-top">
        </div>

        <div class="col-md-12 clear-all content-wrapper marginTop nxt-header">
            {{contentData.nextHeader}}
        </div>
        <div class="col-md-12 clear-all content-wrapper marginTop progressBy">
            {{updateVia === 'E' ? contentData.progressByMail : contentData.progressByText}}
        </div>

        <div class="col-md-12 clear-all content-wrapper marginTop ">
          <div class="col-md-4 content-css oval">
            <div class="mrg-top">1</div>
          </div> 
          <div class="col-md-7 clear-all mrg-left">
            <p class="margin">{{contentData.text1}}</p>
            
        </div> 
        </div>

        <div class="col-md-12 clear-all content-wrapper marginTop ">
            <div class="col-md-4 content-css oval">
            <div class="mrg-top">2</div>
          </div> 
          <div class="col-md-7 clear-all mrg-left">
            <p class="margin">{{contentData.text2}}</p>
            
        </div> 
        </div>
        <div class="col-md-12 clear-all content-wrapper marginTop ">
            <div class="col-md-4 content-css oval">
            <div class="mrg-top">3</div>
          </div> 
          <div class="col-md-7 clear-all mrg-left">
            <p class="margin">{{contentData.text3}}</p>
            
        </div> 
        </div>



        <div class="col-md-12 underline margin-top">
        </div>

      

          <div class="col-md-12 clear-all">
            
            <div class="float-right" *ngIf="responseApplicationData['triggeredBy'] !='HOuser'">
                <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="goToQuoteBTnConfig" [buttonType]="'normalCTA'"></app-content-bottom-nav>
            
            </div>
          </div>
      
      </div>
  </div>
</div>